export const BusinessNameMaxLength = 90;
